import { render, staticRenderFns } from "./ButtonAI.vue?vue&type=template&id=6a9107c6&scoped=true&"
import script from "./ButtonAI.vue?vue&type=script&lang=js&"
export * from "./ButtonAI.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAI.vue?vue&type=style&index=0&id=6a9107c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9107c6",
  null
  
)

export default component.exports